import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncUnregisteredDomainContainer = Loadable({
  loader: () => import('./UnregistredDomainContainer')
});
export default AsyncUnregisteredDomainContainer;